import styled from 'styled-components';
import { SPACING } from '~/common/layout-propertis/spacing';

interface IStyContainer {
  maxSize: string;
  $hasGap: boolean;
}

export const StyContainer = styled.div<IStyContainer>`
  width: 100%;
  max-width: ${({ maxSize }) => maxSize};
  display: flex;
  flex-direction: column;
  gap: ${({ $hasGap }) => $hasGap && SPACING._4};
  width: 100%;
`;

interface IStyTitleContent {
  $keepPercentageEnd: boolean;
}

export const StyTitleContent = styled.div<IStyTitleContent>`
  display: flex;
  width: 100%;
  align-items: start;
  justify-content: ${({ $keepPercentageEnd }) =>
    $keepPercentageEnd ? 'end' : 'space-between'};
`;

export const StyLinearAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._8};
`;
